import { render, staticRenderFns } from "./IconChecked.vue?vue&type=template&id=44bde1cc&"
import script from "./IconChecked.vue?vue&type=script&lang=js&"
export * from "./IconChecked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports